export function showAiActionsHelpMeWrite(): Promise<string | undefined> {
  return new Promise((resolve) => {
    const contents = `
    <style nonce="CSP_STYLE_NONCE_PLACEHOLDER">
        .ai-actions-dialog-backdrop {
            display: flex;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.4);
            align-items: center;
            justify-content: center;
            z-index: 1000000;
        }

        .ai-actions-dialog-frame {
            position: relative;
            background-color: white;
            border-radius: 5px;
            padding: 20px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
            width: 758px;
            display: flex;
            flex-direction: column;
        }

        .ai-actions-dialog-title {
          font-size: 14px;
          font-weight: 400;
          padding-bottom: 9px;
          padding-top: 2px;
        }

        .ai-actions-dialog-body {
            font-size: 14px;
            font-weight: 400;
            padding-bottom: 2px;
            display: flex;
        }

        .ai-actions-dialog-input-frame {
            display: flex;
            align-items: center;
            flex: 1;
            border-radius: 4px;
            border: 1px solid #DBDDE3;
            height: 40px;
        }

        .ai-actions-dialog-magick-icon {
            width: 24px;
            height: 24px;
            background-image: url('/assets/images/icons/ai-actions/help-me-write-black.svg');
            background-repeat: no-repeat;
            background-size: contain;
            margin: 0 7px;
        }

        .ai-actions-dialog-input {
            border: none;
            flex: 1;
            outline: none;
            font-size: 14px;
        }

        .ai-actions-dialog-button {
            font-size: 14px;
            font-weight: 500;
            border-radius: 4px;
            padding: 10px 16px;
            border: none;
        }

        .ai-actions-dialog-secondary-button {
            background-color: #fff;
            color: #3d41eb;
            transition: background-color 0.3s;
        }

        .ai-actions-dialog-secondary-button:hover {
            background-color: #eee;
        }

        .ai-actions-dialog-secondary-button:active {
            background-color: #ddd;
        }

        .ai-actions-dialog-primary-button {
            cursor: pointer;
            background-color: #3d41eb;
            color: #fff;
            transition: background-color 0.3s;
        }

        .ai-actions-dialog-primary-button:hover {
            background-color: #181ce5;
        }

        .ai-actions-dialog-primary-button:active {
            background-color: #1215ac;
        }

        .ai-actions-dialog-go-button {
            background-image: url('/assets/images/icons/ai-actions/ai-actions-button-white.svg');
            background-repeat: no-repeat;
            background-position: 10px center;
            padding-left: 35px;
        }
    </style>

    <div class="ai-actions-dialog-backdrop">
        <div class="ai-actions-dialog-frame">
            <div class="ai-actions-dialog-title">
                Help Me Write
            </div>
            <div class="ai-actions-dialog-body">
                <div class="ai-actions-dialog-input-frame">
                    <div class="ai-actions-dialog-magick-icon"></div>
                    <input type="text" class="ai-actions-dialog-input" placeholder="Use simpler language" autofocus>
                </div>

                <button class="ai-actions-dialog-button ai-actions-dialog-secondary-button
                    ai-actions-dialog-cancel-button">Cancel</button>
                <button class="ai-actions-dialog-button ai-actions-dialog-primary-button
                    ai-actions-dialog-go-button">Go</button>
            </div>
        </div>
    </div>
  `;

    const dialogRoot = document.createElement('div');
    dialogRoot.className = 'ai-actions-dialog-root';
    dialogRoot.innerHTML = contents;

    document.body.appendChild(dialogRoot);
    requestAnimationFrame(() => {
      (dialogRoot.querySelector('.ai-actions-dialog-input') as HTMLInputElement)?.focus();
    });

    function go() {
      resolve((dialogRoot.querySelector('.ai-actions-dialog-input') as HTMLInputElement)?.value);
      dialogRoot.remove(); // Modify as needed
    }

    function cancel() {
      resolve(undefined);
      dialogRoot.remove(); // Modify as needed
    }

    dialogRoot.querySelector('.ai-actions-dialog-cancel-button')?.addEventListener('click', () => {
      cancel();
    });

    dialogRoot.querySelector('.ai-actions-dialog-go-button')?.addEventListener('click', () => {
      go();
    });

    dialogRoot.querySelector('.ai-actions-dialog-input')?.addEventListener('keyup', (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        cancel();
      } else if (e.key === 'Enter') {
        go();
      }
    });
  });
}
